/**
 * Création de campagne pour une organisation, depuis le portail admin.
 * Le formulaire lui-même est partagé avec le portail client — voir
 * `@repo/campagne` (`CampagneCreatorForm`) — seule la donnée qui l'alimente
 * (organisation ciblée, groupes, mutation) diffère.
 */
import { Breadcrumb, PageContainer } from "@repo/ui";
import { CampagneCreatorForm } from "@repo/campagne";
import { useQuery } from "convex/react";
import { useParams } from "react-router";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { arianeOrganisation } from "../../lib/ariane";

export function CampagneCreerAdmin() {
  const { orgId } = useParams<{ orgId: string }>();
  const organisationId = orgId as Id<"organisations">;

  const organisation = useQuery(api.superAdmin.obtenirOrganisation, {
    organisationId,
  });
  const groupes = useQuery(api.superAdmin.listerGroupes, { organisationId });

  const campagnesHref = `/organisations/${organisationId}/campagnes`;

  return (
    <PageContainer>
      <Breadcrumb
        items={[
          ...arianeOrganisation(organisationId, organisation?.nom, "campagnes"),
          { label: "Nouvelle campagne" },
        ]}
      />

      <div className="mt-6">
        <CampagneCreatorForm
          organisationId={organisationId}
          organisationNom={organisation?.nom}
          applicationsAutorisees={organisation?.applicationsAutorisees}
          groupes={groupes}
          includeCandidats={false}
          retourHref={campagnesHref}
          retourLabel="Retour aux campagnes"
          getCampagneHref={(campagneId) => `/campagnes/${campagneId}`}
        />
      </div>
    </PageContainer>
  );
}
